import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HeadersService } from './headers.service';
import { UserStorageService } from './user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class PostService {


  apiURL = environment.apiUrl;
  constructor(private http: HttpClient,private storage: UserStorageService, private headers: HeadersService) {}

  public submit(url: string, formData?: any): Observable<any> {
    return this.http.post<any>(this.apiURL + url, formData,this.headers.setHeaders()).pipe(
      (data) => data,
      (error) => error
    );
  }
}
